module.exports = __webpack_public_path__ + "img/review_light_ic.1a65d561.png";